import { Navigate, Outlet } from 'react-router'
import { ErrorPage } from './pages/404'
import Login from './pages/Login'
import Recover from './pages/Recover'
import Register from './pages/Register'
import ChangePassword from './pages/ChangePassword'
import EntranceLayout from './layouts/EntranceLayout'
import RootLayout from './layouts/RootLayout'
import HomeLayout from './layouts/HomeLayout'
import Explore from './pages/Explore'
import Home from './pages/Home'
import OrgDashboard from './pages/OrgDashboard'
import Settings from './pages/Settings'
import UserProfile from './pages/UserProfile'
import Notification from './pages/Notification'
import SettingProfile from './pages/Settings/Profile'
import UserProfileItem from './pages/UserProfile/Item'
import OrganizationList from './pages/Organizations/List'
import CreateOrganization from './pages/Organizations/Create'
import OrganizationItem from './pages/Organizations/Item'
import SuccessOrganization from './pages/Organizations/Success'
import OrganizationProjects from './pages/Organizations/Item/Projects'
import OrganizationSetting from './pages/Organizations/Item/Setting'
import OrganizationSettingGeneral from './pages/Organizations/Item/Setting/General'
import OrganizationMemberIndex from './pages/Organizations/Item/Members'
import OrganizationFailedInvitations from './pages/Organizations/Item/Members/FailedInvitations'
import OrganizationGroup from './pages/Organizations/Item/Members/Group'
import OrganizationGroupItem from './pages/Organizations/Item/Members/Group/Item'
import OrganizationGroupList from './pages/Organizations/Item/Members/Group/List'
import OrganizationMembers from './pages/Organizations/Item/Members/Members'
import OrganizationOutsideMembers from './pages/Organizations/Item/Members/OutsideMembers'
import OrganizationPendingInvitations from './pages/Organizations/Item/Members/PendingInvitations'
import OrganizationSettingTerms from './pages/Organizations/Item/Setting/Terms'
import { adminRoutes } from './routes/admin'
import { projectRoutes } from './routes/project'
import { Pricing } from './pages/Pricing/Pricing'
import { CheckoutLayout } from './layouts/CheckoutLayout/CheckoutLayout'
import { Checkout } from './layouts/CheckoutLayout/Checkout/Checkout'
import { CheckoutResult } from './layouts/CheckoutLayout/CheckoutResult/CheckoutResult'
import { Activation } from './pages/Activation/Activation'
import { ResetPassword } from './pages/ResetPassword/ResetPassword'
import { ForgotPassword } from './pages/ResetPassword/ForgotPassword'
import { TokenRedirect } from './routes/ActivationRedirect'
import { OPermissionAndElse } from './components/OPermission/OPermission'
import { ROLE_GENERAL } from './components/OPermission/PlanPermission'
import FeaturesLayout from './layouts/FeaturesLayout'
import InviteConfirm from './pages/InviteConfirm'
import OrganizationPhysicalPropertiesTab from './pages/Organizations/Item/PhysicalProperties'
import OrganizationPhysicalPropertiesComponents from './pages/Organizations/Item/PhysicalProperties/Components'
import OrganizationPhysicalPropertiesSets, { OrganizationPropertySetsList, OrganizationPropertySetDetail } from './pages/Organizations/Item/PhysicalProperties/PropertySets'
import { PropertySetBasic } from '@/admin-pages/PropertySets/Item/Basic/PropertySetBasic'
import { PropertySetComponents } from '@/admin-pages/PropertySets/Item/Components/PropertySetComponents'
import { PropertySetReactions } from '@/admin-pages/PropertySets/Item/Reactions/PropertySetReactions'
import { PropertySetReactionSets } from '@/admin-pages/PropertySets/Item/ReactionSets/PropertySetReactionSets'
import OrganizationEquipmentTab from './pages/Organizations/Item/Equipment'
import OrganizationEquipmentList from './pages/Organizations/Item/Equipment/EquipmentList'
import OrganizationEquipmentPaletteContainers from './pages/Organizations/Item/Equipment/PaletteContainers'
import OrganizationEquipmentItem from './pages/Organizations/Item/Equipment/EquipmentItem'
import { EquipmentBasic } from '@/admin-pages/Equipments/Item/Basic/EquipmentBasic'
import { GraphDesign } from '@/admin-pages/Equipments/Item/GraphDesign/GraphDesign'


export const appRoutes = () => [
  {
    path: '404',
    element: <ErrorPage />
  },
  {
    path: 'login',
    element: <Navigate to='/entrance/login' />
  },
  {
    path: 'register',
    element: <Navigate to='/entrance/register' />
  },
  {
    path: 'activation/:token',
    element: <TokenRedirect to="/entrance/activation/:token"/>
  },
  {
    path: 'reset-password/:token',
    element: <TokenRedirect to="/entrance/reset-password/:token"/>
  },
  {
    path: 'entrance',
    element: <EntranceLayout />,
    children: [
      {
        path: '',
        element: <Navigate to='login' />
      },
      {
        path: 'login',
        element: <Login />
      },
      {
        path: 'register',
        element: <Register />
      },
      {
        path: 'change-password',
        element: <ChangePassword />
      },
      {
        path: 'recover',
        element: <Recover />
      },
      {
        path: 'activation/:token',
        element: <Activation />
      },
      {
        path: 'reset-password/:token',
        element: <ResetPassword />
      },
      {
        path: 'forgot-password',
        element: <ForgotPassword />
      }
    ]
  },
  {
    path: 'checkout',
    element: <CheckoutLayout />,
    children: [
      {
        path: '',
        element: <Checkout />
      },
      {
        path: 'result',
        element: <CheckoutResult />
      }
    ]
  },
  {
    path: 'features',
    element: <FeaturesLayout />,
    children: [
      {
        path: 'invite-confirm/:token',
        element: <InviteConfirm />
      }
    ]
  },
  {
    path: '',
    element: <RootLayout />,
    children: [
      ...projectRoutes,
      {
        path: '',
        element: <HomeLayout />,
        children: [
          {
            path: '',
            element: <Navigate to='/home' />
          },
          {
            path: 'home',
            element: <UserProfile />,
            children: [
              {
                path: '',
                element: <Navigate to='/home/organizations' />
              },
              {
                path: 'organizations',
                element: <UserProfileItem />
              },
              {
                path: 'projects',
                element: <UserProfileItem />
              }
            ]
          },
          {
            path: 'explore',
            element: <Explore />
          },
          {
            path: 'pricing',
            element: <Pricing />
          },
          {
            path: 'orgs/:orgId/dashboard',
            element: <OrgDashboard />
          },
          {
            path: 'notification',
            element: <Notification />
          },
          {
            path: 'settings',
            element: <Settings />,
            children: [
              {
                path: '',
                element: <Navigate to='profile' />
              },
              {
                path: 'profile',
                element: <SettingProfile />
              }
            ]
          },
          {
            path: '',
            element: <Outlet />,
            children: [
              {
                path: 'list',
                element: <OrganizationList />
              },
              {
                path: 'create',
                element: <CreateOrganization />
              },
              {
                path: 'success',
                element: <SuccessOrganization />
              },
              {
                path: ':orgId',
                element: <OrganizationItem />,
                children: [
                  {
                    path: '',
                    element: <Navigate to='projects' />
                  },
                  {
                    path: 'projects',
                    element: <OrganizationProjects />
                  },
                  {
                    path: 'physical-properties',
                    element: <OrganizationPhysicalPropertiesTab />,
                    children: [
                      {
                        path: '',
                        element: <Navigate to='components' />
                      },
                      {
                        path: 'components',
                        element: <OrganizationPhysicalPropertiesComponents />
                      },
                      {
                        path: 'property-sets',
                        element: <OrganizationPhysicalPropertiesSets />,
                        children: [
                          {
                            path: '',
                            element: <OrganizationPropertySetsList />
                          },
                          {
                            path: 'create',
                            element: <OrganizationPropertySetDetail />,
                            children: [
                              { path: '', element: <Navigate to='basic' /> },
                              { path: 'basic', element: <PropertySetBasic /> },
                              { path: 'components', element: <PropertySetComponents /> },
                              { path: 'reactions', element: <PropertySetReactions /> },
                              { path: 'reaction-sets', element: <PropertySetReactionSets /> },
                            ]
                          },
                          {
                            path: ':id',
                            element: <OrganizationPropertySetDetail />,
                            children: [
                              { path: '', element: <Navigate to='basic' /> },
                              { path: 'basic', element: <PropertySetBasic /> },
                              { path: 'components', element: <PropertySetComponents /> },
                              { path: 'reactions', element: <PropertySetReactions /> },
                              { path: 'reaction-sets', element: <PropertySetReactionSets /> },
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    path: 'equipment',
                    element: <OrganizationEquipmentTab />,
                    children: [
                      {
                        path: '',
                        element: <Navigate to='equipment' />
                      },
                      {
                        path: 'equipment',
                        element: <OrganizationEquipmentList />
                      },
                      {
                        path: 'equipment/:id',
                        element: <OrganizationEquipmentItem />,
                        children: [
                          { path: '', element: <Navigate to='basic' /> },
                          { path: 'basic', element: <EquipmentBasic /> },
                          { path: 'graph-design', element: <GraphDesign /> },
                        ]
                      },
                      {
                        path: 'palette-containers',
                        element: <OrganizationEquipmentPaletteContainers />
                      }
                    ]
                  },
                  {
                    path: '',
                    element: <OrganizationMemberIndex />,
                    children: [
                      {
                        path: 'manage-members',
                        element: <OrganizationMembers />,
                        children: [
                          {
                            path: 'group',
                            element: <OrganizationGroup />,
                            children: [
                              {
                                path: '',
                                element: <Navigate to='list' />
                              },
                              {
                                path: 'list',
                                element: <OrganizationGroupList />
                              },
                              {
                                path: ':id',
                                element: <OrganizationGroupItem />
                              }
                            ]
                          }
                        ]
                      },
                      {
                        path: 'members',
                        element: <OrganizationOutsideMembers />
                      },
                      {
                        path: 'pending-invitations',
                        element: <OrganizationPendingInvitations />
                      },
                      {
                        path: 'failed-invitations',
                        element: <OrganizationFailedInvitations />
                      }
                    ]
                  },
                  {
                    path: 'setting',
                    element: <OrganizationSetting />,
                    children: [
                      {
                        path: '',
                        element: <Navigate to='general' />
                      },
                      {
                        path: 'general',
                        element: <OrganizationSettingGeneral />
                      },
                      // {
                      //   path: 'unit-set',
                      //   element: <Outlet />,
                      //   children: [
                      //     { path: '', element: <UnitSetList /> },
                      //     { path: 'create', element: <UnitSetItem /> },
                      //     { path: ':id', element: <UnitSetItem /> }
                      //   ]
                      // },
                      {
                        path: 'terms',
                        element: <OrganizationSettingTerms />
                      },
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
    ]
  },
  adminRoutes,
  {
    path: '*',
    element: <Navigate to='404' />
  }
]
